import {Gradient, SceneTitle} from "@client/components/Chrome";
import {JOY_GRADIENT_TOP} from "@client/components/styles";
import * as recipes from "@client/features/recipes";
import * as search from "@client/features/search";
import * as forms from "@client/forms";
import * as router from "@client/router";
import {server} from "@reactivated";
import React from "react";

export const CreateRecipeFromMeal = router.CreateRecipeFromMeal.withHooks((props) => {
    const recipe = props.resolved.update_meal.recreate_recipe;
    return recipes.useRecipeForm({
        initial:
            recipe == null
                ? null
                : {
                      ...recipe,
                      serving_size_unit: recipe.serving_size_unit ?? "",
                      container_unit:
                          recipe.container_unit as server.journal.nutrition.CreateRecipe.values["container_unit"],
                  },
    });
})
    .withIndex((props) => <Gradient>{props.layout.component}</Gradient>)
    .withActions(() => [])
    .withOptions((props) => ({
        title: "Convert Meal to Recipe",
        titleSection: <SceneTitle>Convert to recipe</SceneTitle>,
        back: "Meal",
        scene: {
            kind: "SIMPLE",
            width: "column",
            surface: {kind: "custom", background: JOY_GRADIENT_TOP},
            bottom: {
                kind: "pills",
                primary: {
                    icon: "save",
                    title: "Save",
                    onClick: async () => {
                        const response = await forms.submitForm(props.form, (data) =>
                            server.journal.nutrition.create_recipe_from_meal({
                                ...data,
                                meal_id: props.resolved.update_meal.uuid,
                            }),
                        );
                        if (response?.type === "success") {
                            void props.dispatch(search.loadSearch({reset: true}));
                            void router.replace("journal.journal", {
                                key: props.resolved.update_meal.key,
                            });
                        }
                    },
                },
            },
        },
    }));
